module.exports = __webpack_public_path__ + "static/forecast/weather/daythunderstorm-08f000a61e77c4706b98dbf6ba9b664b.svg";